export enum RadioSize {
  Medium = 'medium',
  Small = 'small',
  Mini = 'mini',
}
